import React, { createContext, useContext, useEffect, useState } from "react";

const SelectedUserContext = createContext();

export const SelectedUserProvider = ({ children }) => {
  const getDefaultWorkspace = () => {
    try {
      // Dual-read fallback: active_workspace first, then selected_user
      const activeWs = localStorage.getItem("active_workspace");
      if (activeWs) return JSON.parse(activeWs);

      const selected = localStorage.getItem("selected_user");
      if (selected) return JSON.parse(selected);

      const loggedUser = localStorage.getItem("user");
      if (loggedUser) return JSON.parse(loggedUser);

      return null;
    } catch (err) {
      console.error("Error reading workspace from localStorage:", err);
      return null;
    }
  };

  const [selectedUser, setSelectedUser] = useState(getDefaultWorkspace);

  // Persist to localStorage under both keys on change
  useEffect(() => {
    if (selectedUser) {
      const serialized = JSON.stringify(selectedUser);
      localStorage.setItem("active_workspace", serialized);
      localStorage.setItem("selected_user", serialized);
    } else {
      localStorage.removeItem("active_workspace");
      localStorage.removeItem("selected_user");

      // fallback to logged in user
      const loggedUser = localStorage.getItem("user");
      if (loggedUser) {
        setSelectedUser(JSON.parse(loggedUser));
      }
    }
  }, [selectedUser]);

  // Sync if localStorage changes (other tab)
  useEffect(() => {
    const sync = () => {
      try {
        const stored = localStorage.getItem("active_workspace")
          || localStorage.getItem("selected_user");
        if (stored) {
          setSelectedUser(JSON.parse(stored));
        } else {
          const loggedUser = localStorage.getItem("user");
          setSelectedUser(loggedUser ? JSON.parse(loggedUser) : null);
        }
      } catch (err) {
        console.error("Error syncing workspace:", err);
      }
    };

    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);

  const user_id = selectedUser?.user_id || null;
  const workspace_id = selectedUser?.user_id || null;

  return (
    <SelectedUserContext.Provider value={{ selectedUser, setSelectedUser, user_id, workspace_id }}>
      {children}
    </SelectedUserContext.Provider>
  );
};

export const useSelectedUser = () => useContext(SelectedUserContext);
